<cbc-container [isLoading]="isLoading" 
[showContainer]="!isLoading" 
title="Acesso Profissões"
description="Gerencie as profissões cadastradas no sistema">
</cbc-container>

@if(!isLoading) {
<div class="container">
  
  @if(professions.length > 0){

  <table mat-table [dataSource]="professions" class="mat-elevation-z8">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>

    <ng-container matColumnDef="councilGroup">
      <th mat-header-cell *matHeaderCellDef>Conselho</th>
      <td mat-cell *matCellDef="let element">
        {{ element.councilGroup }}
      </td>
    </ng-container>

    <ng-container matColumnDef="professionName">
      <th mat-header-cell *matHeaderCellDef>Profissão</th>
      <td mat-cell *matCellDef="let element">
        {{ element.professionName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="specialty">
      <th mat-header-cell *matHeaderCellDef>Especialização</th>
      <td mat-cell *matCellDef="let element">
        {{ element.specialty }}
      </td>
    </ng-container>

    <ng-container matColumnDef="activityArea">
      <th mat-header-cell *matHeaderCellDef>Area de atuação</th>
      <td mat-cell *matCellDef="let element">
        {{ element.activityArea }}
      </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef>Ativo</th>
      <td mat-cell *matCellDef="let element">
        {{ element.active ? "Sim" : "Não" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div>
          <button mat-raised-button (click)="deleteProfession(element.id)">
            Excluir
          </button>

          <button mat-raised-button (click)="activeProfession(element)">
            Ativar/desativar
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsProfessions"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsProfessions"></tr>
  </table>

  }

</div>
}